<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, Todos los derechos reservados
            <i class="fa fa-heart"></i> 
            <a
              href="https://cealfaperu.com/"
              class="font-weight-bold"
              target="_blank"
              >CEALFA </a
            >
          
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://www.conit.pe"
                class="nav-link text-muted"
                target="_blank"
                >Desarrollado con pasión por Conit.pe</a
              >
            </li>
         
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
